import { ITableField } from '../../../../../../shared/Tables/Table'
import timeUtils from '../../../../../../utils/time.utils.ts'
import { IEquipmentModel } from '../../equipmentModels.types.ts'

const equipmentModelsTableFields: ITableField<IEquipmentModel, keyof IEquipmentModel>[] = [
  {
    key: 'createdAt',
    clientSideOrdering: true,
    width: '200px',
    header: 'Дата создания',
    getter: (it) => timeUtils.formatDate(new Date(it.createdAt), 'dd MMM yyyy HH:mm'),
    sortGetter: (it) => new Date(it.createdAt).getTime(),
  },
  {
    key: 'name',
    clientSideOrdering: true,
    width: '500px',
    header: 'Наименование',
    getter: (it) => it.name,
    sortGetter: (it) => it.name,
  },
]

export default equipmentModelsTableFields
